import React from "react"
import { Box, LinearProgress, Skeleton, Stack, Typography } from "@mui/material"
import { LOW_CREDITS_THRESHOLD } from "@/shared/constants/plans"

interface Props {
  creditsRemaining: number
  creditLimit: number
  creditsToBeUsed: number
  creditsAfterUse: number
  isLoading: boolean
}

const CreditProgressBar: React.FC<Props> = ({
  creditsRemaining,
  creditLimit,
  creditsToBeUsed,
  creditsAfterUse,
  isLoading
}) => {
  if (isLoading) {
    return <Skeleton variant="rectangular" height={36} sx={{ borderRadius: 1 }} />
  }

  const progress = creditLimit > 0 ? (creditsAfterUse / creditLimit) * 100 : 0
  const color =
    creditsAfterUse <= 0
      ? "error"
      : creditsAfterUse <= LOW_CREDITS_THRESHOLD
        ? "warning"
        : ("success" as "error" | "warning" | "success")

  const label =
    creditsToBeUsed > 0
      ? `Using ${creditsToBeUsed} credit${creditsToBeUsed !== 1 ? "s" : ""} · ${creditsAfterUse} remaining after generation`
      : `${creditsRemaining} credit${creditsRemaining !== 1 ? "s" : ""} remaining`

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {creditsAfterUse} / {creditLimit}
        </Typography>
      </Stack>
      <LinearProgress variant="determinate" value={progress} color={color} sx={{ borderRadius: 1, height: 8 }} />
    </Box>
  )
}

export default CreditProgressBar
